import { ubuntu } from 'Components/Fonts/ubuntu'

const fonts = {
  primary: `${ubuntu.style.fontFamily}, sans-serif`,
}

export default fonts
